<div class="row">
    <div class="col-xl-12 mx-auto">
        <div class="team-member-form content-wrapper">
            <div class="">
                <div class="">
                    <div class="d-flex" style="background-color: #F44C4C;height:60px;">
                      <div class="col-md-12 d-flex">
                        <div class="col-md-6">
                            <h5 class="mb-0 main-text text-white m-3">Add New Address </h5>
                        </div>
                       <div class="col-md-6 " style="text-align: end;">
                        <button class="close-icon btnn p-0" (click)="closeDialog()"> <i class="bx bx-x"></i></button>

                       </div>
                      </div>

                    </div>
                
             <div class="col-xl-12 p-3" style="height: 330px;overflow:auto">
                <form class="row g-3" [formGroup]="formGroup"  >
                    <div class="col-md-6 ">
                        <div class="form-group">
                            <label for="customerName" class="form-label">Customer Name</label>
                            <div class="input-group">
                                <input type="text" formControlName="city" placeholder="Customer Name" class="form-control"
                                    (keypress)="keyPressAlphabets($event)">
                            </div>
                        </div>
                        <mat-error>
                            <span
                                *ngIf="(submitted && formGroup.get('city')?.errors) || !formGroup.get('city')?.valid && formGroup.get('city')?.touched">Please
                                enter customer name </span>
                        </mat-error>
                    </div>
                    <div class="col-md-12">
                        <div class="form-group">
                            <label for="" class="form-label">Address</label>
                            <div class="input-group">
                                <input type="text-area"  style="height:52px;" formControlName="address" placeholder="Address" class="form-control">
                            </div>
                        </div>
                        <mat-error>
                            <span *ngIf="(submitted && formGroup.get('address')?.errors) || !formGroup.get('address')?.valid && formGroup.get('address')?.touched">Please enter address  </span>
                        </mat-error>
                    </div>
                    <!-- <div class="col-md-6">
                      <div class="form-group">
                          <label for="" class="form-label">Country</label>
                          <div class="input-group">
                              <input type="text" formControlName="typeName" placeholder="Country" class="form-control">
                          </div>
                      </div>
                  </div> -->

                <!-- <div class="col-md-6">
                  <div class="form-group">
                      <label for="" class="form-label">District</label>
                      <div class="input-group">
                          <input type="text" formControlName="district" placeholder="District" class="form-control">
                      </div>
                  </div>
              </div>-->
              <div class="col-md-6">
                <div class="form-group">
                    <label for="" class="form-label">State</label>
                    <div class="input-group">
                        <input type="text" formControlName="state" placeholder="state" class="form-control" (keypress)="keyPressAlphabets($event)">
                    </div>
                    <mat-error>
                        <span *ngIf="(submitted && formGroup.get('state')?.errors) || !formGroup.get('state')?.valid && formGroup.get('state')?.touched">Please enter state  </span>
                    </mat-error>
                </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                  <label for="" class="form-label">Country</label>
                  <div class="input-group">
                      <input type="text" formControlName="country" placeholder="country" class="form-control" (keypress)="keyPressAlphabets($event)">
                  </div>
                  <mat-error>
                    <span *ngIf="(submitted && formGroup.get('country')?.errors) || !formGroup.get('country')?.valid && formGroup.get('country')?.touched">Please enter country  </span>
                </mat-error>
              </div>

          </div> 
          
        
          <div class="col-md-6">
              <div class="form-group">
                  <label for="" class="form-label">PinCode</label>
                  <div class="input-group">
                      <input type="text" formControlName="pincode" placeholder="pin code" class="form-control" (keypress)="keyPressPincodes($event)">
                  </div>
                  <mat-error>
                    <span *ngIf="(submitted && formGroup.get('pincode')?.errors) || !formGroup.get('pincode')?.valid && formGroup.get('pincode')?.touched">Please enter pin code  </span>
                </mat-error>
              </div>
          </div>
         
            <!-- <div class="col-md-6">
              <div class="form-group">
                  <label for="" class="form-label">Sub-Area</label>
                  <div class="input-group">
                      <input type="text" formControlName="officeName" placeholder="Sub-Area" class="form-control">
                  </div>
              </div>
          </div> -->
                  <div class="d-flex">
                    <div class="col-6  mt-5" style="text-align: center;">
                        <button type="submit" class="btn btn-secondary px-5 text-white" (click)="shppingaddress()" >DELIVER TO THIS ADDRESS</button>
                    </div>
                    <div class="col-6  mt-5" style="text-align: center;"> 
                        <button type="submit" class="btn btn-primary  px-5 text-white" (click)="closeDialog()"  > CANCEL</button>
                    </div>
                  </div>
                </form>
             </div>
                </div>
            </div>
        </div>
    </div>
  </div>
